import React, { useEffect, useRef, useState } from "react";
import styles from "./TitledTextField.module.css";
import { useEffectOnce } from "../../../hooks";
import { CustomTextField, CustomTooltip, icon, IconComponent } from "../..";

const TitledTextField = ({
	adornment,
	disabled = false,
	max = "",
	min = "",
	onChange,
	placeholder = "",
	required = false,
	title,
	tooltip = "",
	type = "text",
	value = "",
}) => {
	const [localValue, setLocalValue] = useState("");
	const spanRef = useRef(null);
	const [width, setWidth] = useState(0);
	useEffect(() => {
		if (spanRef.current) {
			setWidth(spanRef.current.offsetWidth);
		}
	}, [localValue]);
	useEffectOnce(
		() => {
			setLocalValue(value);
		},
		[value],
		() => value
	);
	const handleChangeValue = (e) => {
		const { value: v } = e.target;
		let newValue = v;
		if (type === "number") {
			newValue = v.replace(/[^0-9]/g, "");
		}
		setLocalValue(newValue);
		if (typeof onChange === "function") {
			onChange(newValue);
		}
	};
	return (
		<div className={styles.container}>
			<div className={styles.title}>
				{title}
				{required && (
					<span className={styles.required}>
						{tooltip && (
							<CustomTooltip title={tooltip}>
								<IconComponent color="var(--icon-secondary)" icon={icon.faQuestionCircle} size="xs" />
							</CustomTooltip>
						)}
						*
					</span>
				)}
			</div>
			<CustomTextField
				className={styles.textfield}
				disabled={disabled}
				inputProps={{
					min,
					max,
				}}
				placeholder={placeholder}
				type={type}
				value={localValue}
				onChange={handleChangeValue}
			/>
			{adornment && localValue && (
				<>
					<span ref={spanRef} className={styles.textfieldMirror}>
						{localValue}
					</span>

					<div
						className={styles.adornment}
						style={{
							left: 28 + width,
						}}
					>
						{adornment}
					</div>
				</>
			)}
		</div>
	);
};

export default TitledTextField;
